module.exports = __webpack_public_path__ + "img/emi.abf7e478.jpeg";